import { c as _c } from "react/compiler-runtime";
import type { DisplayAvailabilityState } from '@/lib/availability-types';
interface BackorderNoticeProps {
  state: DisplayAvailabilityState;
  className?: string;
}

/**
 * Inline availability notice shown on the PDP/cart when a unit is backordered or
 * (for a no-backorder product) out of stock. Renders nothing when available.
 * Driven by the live availability lookup (POST /api/products/availability).
 */
export function BackorderNotice(t0) {
  const $ = _c(8);
  const {
    state,
    className
  } = t0;
  if (state === "available") {
    return null;
  }
  if (state === "backordered") {
    const t1 = `flex items-center gap-1.5 text-sm text-gray-900 ${className ?? ""}`;
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span className="rounded-sm bg-yellow-400 px-1 font-bold text-gray-950">Backordered</span>;
      t3 = <span>Contact your sales rep for a delivery timeline.</span>;
      $[0] = t2;
      $[1] = t3;
    } else {
      t2 = $[0];
      t3 = $[1];
    }
    let t4;
    if ($[2] !== t1) {
      t4 = <div role="status" className={t1}>{t2}{t3}</div>;
      $[2] = t1;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  const t1 = `flex items-start gap-2 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-800 ${className ?? ""}`;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span aria-hidden="true">⛔</span>;
    t3 = <span><strong>Out of stock.</strong> This item is no longer available and cannot be ordered.</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1) {
    t4 = <div role="status" className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}